// JsFromRoutes CacheKey 54e2a037456fc62e58cd88745a928f0f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  loginLink: /* #__PURE__ */ definePathHelper('get', '/login-link/:token'),
  loginLinkPage: /* #__PURE__ */ definePathHelper('get', '/login-link-page'),
  new: /* #__PURE__ */ definePathHelper('get', '/login'),
  create: /* #__PURE__ */ definePathHelper('post', '/login'),
  verifyEmail: /* #__PURE__ */ definePathHelper('post', '/consumer/sessions/verify_email'),
  forgotPassword: /* #__PURE__ */ definePathHelper('post', '/consumer/sessions/forgot_password'),
  sendLoginLink: /* #__PURE__ */ definePathHelper('post', '/consumer/sessions/send_login_link'),
}
